import React, { useContext, useEffect, useState } from "react";
import CustomTableFooter from "./Footer";
import {
  Button,
  ButtonCancel,
  ButtonCreate,
  ButtonDelete,
  Column,
  Container,
  Root,
  Tittle,
} from "./style";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import useTable from "../Purch/TableLines/useTable";
import useWindowDimensions from "../../../customhooks/useWindowDimensions";
import { useTranslation } from "react-i18next";
import AddIcon from "@mui/icons-material/Add";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Input,
  InputAdornment,
  LinearProgress,
  OutlinedInput,
  TextField,
} from "@mui/material";
import { ContactContext } from "../../../context/contact/ContactContext";
import { Delete, Key, Visibility, VisibilityOff } from "@mui/icons-material";
import UpdateDialog from "./updateDialog";
import UpdatePasswordDialog from "./password";
import DeleteDialog from "./delete";

const data = [
  {
    name: "prueba1",
    lastname: "ape1",
  },
  {
    name: "prueba2",
    lastname: "ape2",
  },
  {
    name: "prueba3",
    lastname: "ape3",
  },
];

const Carrier = () => {
  const { t } = useTranslation();
  const {
    carrierContact,
    currentContact,
    getAllCarrierContact,
    createCarrierContact,
  } = useContext(ContactContext);
  const [updateWindow, setUpdateWindow] = useState(false);
  const [dialogUpdate, setShowDialogUpdate] = useState(false);
  const [page, setPage] = useState(1);
  const [isLoading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [showPassword, setshowPassword] = useState(false);
  const [carrier, setShipper] = useState({
    name: "",
    lastName: "",
    email: "",
    password: "",
  });
  const [open, setOpen] = useState(false);
  const [contactUpdate, setContactUpdate] = useState({});
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [textTittleUpdateDialog, setTextTittleUpdateDialog] = useState("");
  const rowsPerPage = 30;
  const { width } = useWindowDimensions();
  const { slice, range } = useTable(carrierContact, page, rowsPerPage);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleShipperInfo = (event) => {
    setShipper({ ...carrier, [event.target.name]: event.target.value });
  };
  const handleOpenDeleteDialog = (infoContact) => {
    setContactUpdate(infoContact);
    setShowDeleteDialog(true);
  };
  const handleOpenDialogUpdatePassword = (infoContact) => {
    setContactUpdate(infoContact);
    setshowPassword(true);
  };

  const handleCreateShipper = (event) => {
    event.preventDefault();
    setTextTittleUpdateDialog(t("savingInformation"));
    setShowDialogUpdate(true);
    createCarrierContact(carrier)
      .then((resp) => {
        setOpen(false);
        setSuccess(true);
        setUpdateWindow((value) => !value);
        setTimeout(() => {
          setShowDialogUpdate(false);
        }, 1500);
      })
      .catch((error) => {
        setShowDialogUpdate(false);
        alert(error);
      });
  };

  useEffect(() => {
    const fetchData2 = async () => {
      await Promise.all([getAllCarrierContact(currentContact.guid)]);
      setLoading(false);
    };
    fetchData2();
  }, [updateWindow]);

  useEffect(() => {
    const fetchData2 = async () => {
      await Promise.all([getAllCarrierContact(currentContact.guid)]);
      setLoading(false);
    };
    fetchData2();
  }, []);

  return (
    <>
      {isLoading && <LinearProgress color="error" />}
      <DeleteDialog
        contactUpdate={contactUpdate}
        showDialog={showDeleteDialog}
        setShowDialog={setShowDeleteDialog}
        setUpdateWindow={setUpdateWindow}
      />
      <UpdateDialog
        success={success}
        showDialogUpdate={dialogUpdate}
        setShowDialogUpdate={setShowDialogUpdate}
        textTittle={textTittleUpdateDialog}
      />
      <UpdatePasswordDialog
        contactUpdate={contactUpdate}
        showDialog={showPassword}
        setShowDialog={setshowPassword}
      />
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{t("createAccount")}</DialogTitle>
        <form
          onSubmit={(e) => {
            handleCreateShipper(e);
          }}
        >
          <DialogContent>
            <TextField
              required
              autoFocus
              value={carrier.name}
              margin="dense"
              id="name"
              name="name"
              label={t("name")}
              type="text"
              fullWidth
              variant="standard"
              onChange={(e) => handleShipperInfo(e)}
            />
            <TextField
              required
              margin="dense"
              value={carrier.lastName}
              id="lastName"
              name="lastName"
              label={t("lastName")}
              type="text"
              fullWidth
              variant="standard"
              onChange={(e) => handleShipperInfo(e)}
            />
            <TextField
              required
              margin="dense"
              value={carrier.email}
              id="email"
              name="email"
              label={t("email")}
              type="email"
              fullWidth
              variant="standard"
              onChange={(e) => handleShipperInfo(e)}
            />
            {/* <TextField
              required
              margin="dense"
              value={carrier.password}
              id="password"
              name="password"
              label={t("password")}
              type={showPassword ? "text" : "password"}
              fullWidth
              variant="standard"
              inputProps={{
                minLength: 8,
              }}
              onChange={(e) => handleShipperInfo(e)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={handleClickShowPassword} edge="end">
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            /> */}
          </DialogContent>
          <DialogActions>
            <ButtonCancel onClick={handleClose}>{t("cancel")}</ButtonCancel>
            <ButtonCreate type="submit">{t("save")}</ButtonCreate>
          </DialogActions>
        </form>
      </Dialog>
      <Root>
        <Tittle>{t("carrierInformation")}</Tittle>
        <Container
          style={{
            border: "1px solid",
            borderColor: "#f1f1f1",
            borderRadius: "15px",
          }}
        >
          <div
            className={"tableFooterTop"}
            style={{
              backgroundColor: "#f1f1f1",
              justifyContent: "flex-end",
              paddingRight: "10px",
            }}
          >
            <div>
              <Button onClick={handleClickOpen}>
                {width > 550 && t("add")}

                <AddIcon sx={{ fontSize: "28px" }} />
              </Button>
            </div>
          </div>
          <CustomTableFooter
            range={range}
            slice={slice}
            setPage={setPage}
            page={page}
            side={1}
          />
          {slice.length > 0 ? (
            <Table className="table">
              <Thead className="tableRowHeader">
                <Tr>
                  <Th className="tableHeader">{t("name")}</Th>
                  <Th className="tableHeader">{t("email")}</Th>
                  <Th className="tableHeader">{t("actions")}</Th>
                </Tr>
              </Thead>
              <Tbody>
                {slice.length > 0 &&
                  slice.map((item, index) => (
                    <Tr
                      className="tableRowItems"
                      style={{ borderColor: "#fff" }}
                      key={index}
                    >
                      <Td className="tableCell">
                        {item.givenName} {item.surname}
                      </Td>
                      <Td className="tableCell">
                        {
                          item.identities.filter(
                            (x) => x.signInType === "emailAddress"
                          )[0].issuerAssignedId
                        }
                      </Td>
                      <Td className="tableCell">
                        <ButtonDelete>
                          <Key
                            onClick={() => handleOpenDialogUpdatePassword(item)}
                            sx={{
                              fontSize: "40px",
                              ["@media (max-width:390px)"]: {
                                fontSize: "20px",
                              },
                            }}
                          />
                        </ButtonDelete>
                        <ButtonDelete>
                          <Delete
                            onClick={() => handleOpenDeleteDialog(item)}
                            sx={{
                              fontSize: "40px",
                              ["@media (max-width:390px)"]: {
                                fontSize: "20px",
                              },
                            }}
                          />
                        </ButtonDelete>
                      </Td>
                    </Tr>
                  ))}
              </Tbody>
            </Table>
          ) : (
            <div style={{ justifyContent: "center", width: "100%" }}>
              <h3>{t("noInformation")}</h3>
            </div>
          )}
          <CustomTableFooter
            range={range}
            slice={slice}
            setPage={setPage}
            page={page}
            side={2}
          />
        </Container>
      </Root>
    </>
  );
};

export default Carrier;
